import { useTranslation } from "react-i18next";
import { getTranslatedLabel } from "../../../utils/helpers";
import { useAppDispatch } from "../../../redux";
import { useEffect, useState } from "react";
import { getFormFieldOptions } from "../../../redux/reducer/formReducer";
import ButtonIcon from "../buttonIcon";

const SelectBoxRHF = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const { register, formField, errors } = props;
  const label = getTranslatedLabel(formField.translations);

  /**
   * state variable.
   */
  const [options, setOptions] = useState([]);

  /**
   * fetch options
   */
  useEffect(() => {
    if (formField._id) {
      fetchOptions(formField._id);
    }
  }, [formField._id]);

  const fetchOptions = async (id: any) => {
    const options = await dispatch(getFormFieldOptions(id));
    if (options) {
      setOptions(options);
    }
  };

  /**
   * css variable.
   */
  const styles = errors[formField.name] ? "border border-danger" : "";

  return (
    <div className='mb-2'>
      <div
        className={`DatePickerInput mb-2 w-100 mt-0 ms-0 d-flex align-item-center justify-content-center input`}
      >
        <select
          {...register}
          type={formField.type}
          name={formField.name}
          className={`form-control Input showCharacters custom-select ${styles}`}
        >
          <option value="">{t("select-option")}</option>
          {options.map((option: any, key: number) => (
            <option key={key} value={option.key}>
              {option.name}
            </option>
          ))}
        </select>

        <ButtonIcon
          icon="arrow_drop_down"
          handleClick={(e: any) => e.preventDefault()}
        />
      </div>

      {errors[formField.name] && (
        <div className="validation-errors-text-size text-danger mt-1 ms-2">
          {t("dynamic-form.required", { param: label })}
        </div>
      )}
    </div>
  );
};

export default SelectBoxRHF;
